import { createTheme } from '@mui/material/styles'

// assets
import colors from 'assets/scss/_themes-vars.module.scss'

// project imports
import componentStyleOverrides from './compStyleOverride'
import themePalette from './palette'
import themeTypography from './typography'

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

const theme = (customization, serverTheme) => {
  const color = colors
  const themeOption = {
    primaryMain: serverTheme.palette?.primary?.main,
    secondaryMain: serverTheme.palette?.secondary?.main,
    textPrimary: serverTheme.palette?.text?.primary,
    textSecondary: serverTheme.palette?.text?.secondary,
    background: serverTheme.palette?.background?.default,
    backgroundSurface: serverTheme.palette?.background?.surface,
    backgroundHover: serverTheme.palette?.background?.hover,
    backgroundSidebar: serverTheme.palette?.background?.sidebar,
    divider: serverTheme.palette?.divider,
    heading: serverTheme.palette?.text?.primary,
    paper: serverTheme.palette?.background?.surface,
    backgroundDefault: serverTheme.palette?.background?.default,
    darkTextPrimary: serverTheme.palette?.text?.primary,
    darkTextSecondary: serverTheme.palette?.text?.secondary,
    textDark: serverTheme.palette?.text?.primary,
    menuSelected: serverTheme.palette?.secondary?.dark,
    menuSelectedBack: serverTheme.palette?.secondary?.light,
    primary200: serverTheme.palette?.primary?.['200'],
    primary800: serverTheme.palette?.primary?.['800'],
    sidebar: serverTheme.palette?.background?.sidebar,
    customization,
    colors: {
      ...color,
      primaryMain: serverTheme.palette?.text?.primary,
      secondaryDark: serverTheme.palette?.secondary?.dark,
      backgroundDefault: serverTheme.palette?.background?.default
    }
  }

  const themeOptions = {
    direction: 'ltr',
    palette: { ...themePalette(themeOption), mode: 'dark' },
    mixins: {
      toolbar: {
        minHeight: '48px',
        padding: '16px',
        '@media (min-width: 600px)': {
          minHeight: '48px'
        }
      }
    },
    typography: themeTypography(themeOption)
  }

  const themes = createTheme(themeOptions)
  themes.components = componentStyleOverrides(themeOption)
  return themes
}

export default theme
